import { ReactNode } from 'react';
import { cn } from '@anytag/shared-utils';
import { CircularProgress, ModalBody } from '@anytag/shared-atoms';

export interface BodyProps {
  loading?: boolean;
  className?: string;
  children?: ReactNode;
}

export const Body = ({ loading, children, className }: BodyProps) => (
  <ModalBody className={cn('pb-0', className)}>
    <div className="min-h-88">
      {loading ? (
        <div className="flex size-full min-h-[inherit] items-center justify-center">
          <CircularProgress size={64} thickness={1} className="bg-black-30" />
        </div>
      ) : (
        <div className="min-h-[inherit]">{children}</div>
      )}
    </div>
  </ModalBody>
);
